import React from 'react';
import { REPORT_PRINT_THEME, REPORT_PRINT_TYPO } from '../../../utils/dailyReport/reportPrintTheme';

function ZoneLegendPanel({ zoneLegend }) {
  if (!zoneLegend?.length) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '210px',
        maxHeight: 'calc(100% - 20px)',
        overflowY: 'auto',
        background: 'rgba(255, 255, 255, 0.94)',
        border: `1px solid ${REPORT_PRINT_THEME.border}`,
        borderRadius: '6px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
        padding: '10px 12px',
        boxSizing: 'border-box',
        zIndex: 2,
      }}
    >
      <div
        style={{
          ...REPORT_PRINT_TYPO.label,
          color: REPORT_PRINT_THEME.text,
          marginBottom: '8px',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
        }}
      >
        Zone
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {zoneLegend.map(({ zone, color, count, totalDepthM }) => (
          <div
            key={zone}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '8px',
            }}
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: color,
                border: '2px solid #ffffff',
                boxShadow: `0 0 0 1px ${REPORT_PRINT_THEME.border}`,
                flexShrink: 0,
                marginTop: '2px',
              }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  ...REPORT_PRINT_TYPO.body,
                  color: REPORT_PRINT_THEME.text,
                  fontWeight: 600,
                  lineHeight: 1.25,
                }}
              >
                {zone}
              </div>
              <div
                style={{
                  ...REPORT_PRINT_TYPO.footnote,
                  color: REPORT_PRINT_THEME.textLight,
                  marginTop: '2px',
                }}
              >
                {count} holes • {totalDepthM.toLocaleString()}m
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const PrintCurrentDrillingLocations = ({
  mapSnapshotDataUrl,
  zoneLegend,
}) => (
  <div
    style={{
      width: '100%',
      maxWidth: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      background: REPORT_PRINT_THEME.background,
      color: REPORT_PRINT_THEME.text,
      boxSizing: 'border-box',
    }}
  >
    <div
      style={{
        position: 'relative',
        flex: 1,
        width: '100%',
        minHeight: 0,
        border: `1px solid ${REPORT_PRINT_THEME.border}`,
        borderRadius: '4px',
        overflow: 'hidden',
        background: REPORT_PRINT_THEME.backgroundMuted,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {mapSnapshotDataUrl ? (
        <img
          src={mapSnapshotDataUrl}
          alt="Current drilling locations map"
          style={{
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
      ) : (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            ...REPORT_PRINT_TYPO.body,
            color: REPORT_PRINT_THEME.textLight,
          }}
        >
          Map snapshot unavailable
        </div>
      )}

      <ZoneLegendPanel zoneLegend={zoneLegend} />
    </div>
  </div>
);

export default PrintCurrentDrillingLocations;
